import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Menu, Image, useApplicationTheme, ProductLine } from '@adc/ui-core'
import classNames from 'classnames/bind'
import auctioncomLogo from '../../../img/logo-light.svg'
import smartsaleLogo from '../../../img/smartsale-powered-logo.svg'
import MenuItem from '../menuItem'
import NativeAppBanner from '../../nativeAppBanner'
import cls from './styles.scss'
const cx = classNames.bind(cls)

const LogoHeader = ({ customLogo, isSticky }) => {
  const theme = useApplicationTheme()
  const themeLogo =
    theme.productLine === ProductLine.SmartSale ? smartsaleLogo : auctioncomLogo
  const defaultLogo = (
    <Image
      className={cx('icon')}
      src={customLogo || themeLogo}
      data-elm-id='h_logo'
      alt='logo'
    />
  )

  return (
    <header>
      <div
        data-elm-id='header'
        className={cx('header', isSticky ? 'sticky-header' : '')}
      >
        <NativeAppBanner track={_.noop} isSticky={isSticky} />

        <div className={cx('menu')}>
          <Menu borderless size='large' icon>
            {theme.productLine === ProductLine.SmartSale ? (
              <div className={cx('logo-container')}>{defaultLogo}</div>
            ) : (
              <MenuItem url='/'>{defaultLogo}</MenuItem>
            )}
          </Menu>
        </div>
      </div>
      {isSticky && <div className={cx('sticky-header-spacer')} />}
    </header>
  )
}

LogoHeader.propTypes = {
  customLogo: PropTypes.string,
  isSticky: PropTypes.bool,
}

LogoHeader.defaultProps = {
  isSticky: true,
}

export default LogoHeader
